<div class="row">
    <div class="col-md-12">
        <app-alert-modal *ngIf="alertSuccess"></app-alert-modal>
        <app-alert-save-modal *ngIf="alertSuccessOnSave"></app-alert-save-modal>
        <div class="alert alert-danger" *ngIf="alertFailure">
            Something went wrong while uploading file!
        </div>
        <div class="alert alert-danger" *ngIf="timeOutError">
            {{timeoutErrorMessage}}
        </div>
        <div class="col-md-5 mt-5 mb-3 event-action-label form-font-family">
            <span class="create-events-title color">{{actionTitle}} BUDGET REQUEST</span>
            <span class="pt-2" style="font-size: 13px;"><a href="assets/userguides/BudgetCreationUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
        </div>
        <form class="form-horizontal form-padding form-font-family" [formGroup]="expenseClaimForm"
            id="expenseClaimForm">
            <div class="row row-flex">
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height"
                    [ngClass]="{'pointerDisable':(actionTitle == 'EDIT' || disable == true)}">
                    <label for="chapterId" class="control-label col-md-4">Chapter<span
                            class="mandatory-asterisk">*</span></label>

                    <div class="col-md-8" [ngClass]="{'disableSection':(actionTitle == 'EDIT' || disable == true)}">
                       
                        <ng-select formControlName="chapterId" placeholder="--Select--" [items]="chapterDropDownList"
                            bindLabel="siteName" bindValue="chapterId" class="form-control input-lg custom"
                            (change)="getEventListBasedOnChapterSelection(expenseClaimForm.get('chapterId').value,expenseClaimForm.get('eventId').value);getHoshinItemsBasedOnChapterSelection(expenseClaimForm.get('chapterId').value,expenseClaimForm.get('eventId').value,expenseClaimForm.get('hoshinId').value)"></ng-select>
                    </div>
                </div>


                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="hoshinType" class="control-label col-md-4">Business Drivers<span
                            class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8">
                       
                        <ng-select formControlName="hoshinType" placeholder="--Select--" [items]="HoshinDropDownList"
                            bindLabel="hoshinType" bindValue="hoshinType"
                            class="form-control input-lg custom"></ng-select>
                    </div>
                </div>

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height"
                    [ngClass]="{'pointerDisable':(actionTitle == 'EDIT' || disable == true)}">
                    <label for="isEventExpense" class="control-label col-md-4">Event Expense<span
                            class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8 radio-button-padding"
                        [ngClass]="{'disableSection':(actionTitle == 'EDIT' || disable == true)}"
                        (change)="disableInputBasedOnSelection(expenseClaimForm.get('isEventExpense').value);getHoshinItemsBasedOnChapterSelection(expenseClaimForm.get('chapterId').value,expenseClaimForm.get('eventId').value,expenseClaimForm.get('hoshinId'))">
                        <input class="radio-input-align" type="radio" name="isEventExpense" [value]="true"
                            formControlName="isEventExpense" /> Yes
                        <input class="radio-input-align radio-input-margin" type="radio" name="isEventExpense"
                            [value]="false" formControlName="isEventExpense" /> No
                    </div>
                </div>

                <div *ngIf="expenseClaimForm.get('isEventExpense').value == true"
                    class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height"
                    [ngClass]="{'pointerDisable':(actionTitle == 'EDIT' || disable == true)}">
                    <label for="eventId" class="control-label col-md-4">Event Name<span
                            class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8" [ngClass]="{'disableSection':(actionTitle == 'EDIT' || disable == true)}">
                       
                        <ng-select formControlName="eventId" placeholder="--Select--" [items]="eventList"
                            bindLabel="eventName" bindValue="eventId" class="form-control input-lg custom"
                            (change)="getHoshinItemsBasedOnChapterSelection(expenseClaimForm.get('chapterId').value,expenseClaimForm.get('eventId').value)"></ng-select>
                    </div>
                </div>


                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height"
                    [ngClass]="{'pointerDisable':(actionTitleHoshin == 'DISABLE')}">
                    <label for="hoshinId" class="control-label col-md-4">Annual Plan Items<span
                            class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8" [ngClass]="{'disableSection':(actionTitleHoshin == 'DISABLE') || (this.editExpenseData != null && this.editExpenseData.expenseStatus == 'SCHEDULED')}">
                        <ng-select formControlName="hoshinId" placeholder="--Select--" [items]="HoshinDropDown"
                            bindLabel="bpgInitiative" bindValue="hoshinId" class="form-control input-lg custom"
                            [(ngModel)]="hoshinId"></ng-select>
                    </div>
                </div>


                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="expenseName" class="control-label col-md-4">Expense Name<span
                            class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8">
                        <input type="text" (blur)="trimValue(this.expenseClaimForm.get('expenseName'))"
                            [maxlength]="100" autocomplete="off" placeholder="Enter expense name" name="expenseName"
                            class="form-control input-lg" formControlName="expenseName">
                    </div>
                </div>

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="totalExpense" class="control-label col-md-4">Total Expense ($)<span
                            class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8">
                        <input type="number"
                            onkeypress="return !((event.charCode == 46||event.charCode == 101||event.charCode == 69)) && (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
                            [maxlength]="250" autocomplete="off" placeholder="Enter total expense" name="totalExpense"
                            class="form-control input-lg" formControlName="totalExpense">
                    </div>
                </div>

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height text-area-full-height">
                    <label for="expenseDesc" class="control-label col-md-4">Expense Description<span
                            class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><textarea (blur)="trimValue(this.expenseClaimForm.get('expenseDesc'))"
                            [maxlength]="500" autocomplete="off" placeholder="Enter expense description"
                            class="form-control form-control-inline text-area-width text-area-height" id="expenseDesc"
                            name="expenseDesc" [maxlength]="500" formControlName="expenseDesc"></textarea></div>
                </div>

                <!-- <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height text-area-full-height">
                    <label for="detailedEventPurpose" class="control-label col-md-4">Purpose<span
                            class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><textarea
                            (blur)="trimValue(this.expenseClaimForm.get('detailedEventPurpose'))" [maxlength]="500"
                            autocomplete="off" placeholder="Enter purpose"
                            class="form-control form-control-inline text-area-width text-area-height"
                            id="detailedEventPurpose" name="detailedEventPurpose" [maxlength]="500"
                            formControlName="detailedEventPurpose"></textarea></div>
                </div> -->


                <!-- for the alignmnet when isEventExpense is true -->
                <!-- <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height text-area-full-height div-height"
                    *ngIf="expenseClaimForm.get('isEventExpense').value == true">
                </div> -->

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="supportingDoc1" class="control-label col-md-4">Supporting Doc 1</label>
                    <div class="col-md-8"><input type="file" id="supportingDoc1" (change)="onFileSelected($event,1)"
                            name="supportingDoc1" placeholder="Upload"
                            class="form-control input-lg upload-icon hideInput">
                        <a class="deleteButton delete-button-style zoom-in-style" title="delete"
                            (click)="removeFile(1)"><img src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
                        <label class="form-control input-lg upload-icon file-name-padding" for="supportingDoc1"><label
                                class="docNameEllipsis">{{supportingDoc1Name}}</label></label>
                    </div>
                </div>

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="supportingDoc2" class="control-label col-md-4">Supporting Doc 2</label>
                    <div class="col-md-8"><input type="file" id="supportingDoc2" (change)="onFileSelected($event,2)"
                            name="supportingDoc2" placeholder="Upload"
                            class="form-control input-lg upload-icon hideInput">
                        <a class="deleteButton delete-button-style zoom-in-style" title="delete"
                            (click)="removeFile(2)"><img src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
                        <label class="form-control input-lg upload-icon file-name-padding" for="supportingDoc2"><label
                                class="docNameEllipsis">{{supportingDoc2Name}}</label></label>
                    </div>
                </div>

                <span class="validation-error-message" *ngIf="fileExtensionError">You can only upload the file of type
                    jpg,jpeg,png,pdf,ppt,pptx,txt,doc,docx,xlsx,xls,csv</span>
                <span class="validation-error-message" *ngIf="fileSizeExtensionError">You can only upload the file of
                    size less than 5MB </span>





                <div *ngIf="this.editExpenseData != null && (this.editExpenseData.expenseStatus == 'APPROVED')"
                    class="col-md-5 col-sm-6 col-xs-12 form-row">
                    <span class="control-label col-md-4">Approval By</span>
                    <span class="col-md-6 coment-style">{{this.editExpenseData.secondLevelName}} </span>
                </div>
                <div *ngIf="this.editExpenseData != null && (this.editExpenseData.expenseStatus == 'APPROVED')"
                    class="col-md-5 col-sm-6 col-xs-12 form-row">
                    <span class="control-label col-md-4">Approval Comment</span>
                    <span class="col-md-6 coment-style">{{this.editExpenseData.superAdminApprovalComment}}</span>
                </div>

                <div *ngIf="this.editExpenseData != null && (this.editExpenseData.expenseStatus == 'REJECTED')"
                    class="col-md-5 col-sm-6 col-xs-12 form-row">
                    <span class="control-label col-md-4">Rejected By</span>
                    <span class="col-md-6 coment-style">{{this.editExpenseData.secondLevelName}}</span>
                </div>
                <div *ngIf="this.editExpenseData != null && (this.editExpenseData.expenseStatus == 'REJECTED')"
                    class="col-md-5 col-sm-6 col-xs-12 form-row">
                    <span class="control-label col-md-4">Reject Comment</span>
                    <span class="col-md-6 coment-style">{{this.editExpenseData.superAdminApprovalComment}}</span>
                </div>




            </div>
            <span class="respone-hide initiative-style">
<span
                    *ngIf="(expenseClaimForm.get('chapterId').value == null || expenseClaimForm.get('hoshinType').value == null || expenseClaimForm.get('hoshinType').value == '' ||
                    (expenseClaimForm.get('eventId').value == null && expenseClaimForm.get('isEventExpense').value)
                    ||  expenseClaimForm.get('hoshinId').value == null|| expenseClaimForm.get('expenseName').value == null ||
                     expenseClaimForm.get('expenseName').value == '' 
                    || expenseClaimForm.get('totalExpense').value == null || expenseClaimForm.get('expenseDesc').value == null || 
                    expenseClaimForm.get('expenseDesc').value== '')"
                  >
                    Missing fields : </span>
                <span *ngIf="expenseClaimForm.get('chapterId').value == null">Chapter</span>
                <span
                    *ngIf="(expenseClaimForm.get('hoshinType').value == null || expenseClaimForm.get('hoshinType').value == '' ||
                    (expenseClaimForm.get('eventId').value == null && expenseClaimForm.get('isEventExpense').value)
                    ||  expenseClaimForm.get('hoshinId').value == null|| expenseClaimForm.get('expenseName').value == null ||
                     expenseClaimForm.get('expenseName').value == '' 
                    || expenseClaimForm.get('totalExpense').value == null || expenseClaimForm.get('expenseDesc').value == null || 
                    expenseClaimForm.get('expenseDesc').value== '')"
                    [hidden]="expenseClaimForm.get('chapterId').value != null">,</span>
                <span
                    *ngIf="expenseClaimForm.get('hoshinType').value == null || expenseClaimForm.get('hoshinType').value == ''">
                    Business Drivers
                </span>
                <span
                    [hidden]="expenseClaimForm.get('hoshinType').value != null && expenseClaimForm.get('hoshinType').value != ''"
                    *ngIf="((expenseClaimForm.get('eventId').value == null && expenseClaimForm.get('isEventExpense').value) 
                    ||  expenseClaimForm.get('hoshinId').value == null || expenseClaimForm.get('expenseName').value == null || 
                     expenseClaimForm.get('expenseName').value == '' ||
                    expenseClaimForm.get('totalExpense').value == null || expenseClaimForm.get('expenseDesc').value == null ||
                     expenseClaimForm.get('expenseDesc').value== '')">,</span>
                     
                <span *ngIf="expenseClaimForm.get('eventId').value == null &&  expenseClaimForm.get('isEventExpense').value"> Event</span>
                <span [hidden]="(!expenseClaimForm.get('isEventExpense').value || (expenseClaimForm.get('eventId').value != null && expenseClaimForm.get('isEventExpense').value))"
                *ngIf="(expenseClaimForm.get('hoshinId').value == null || expenseClaimForm.get('expenseName').value == null || 
                 expenseClaimForm.get('expenseName').value == '' ||
                expenseClaimForm.get('totalExpense').value == null || expenseClaimForm.get('expenseDesc').value == null ||
                 expenseClaimForm.get('expenseDesc').value== '')">,</span>
                <span *ngIf=" expenseClaimForm.get('hoshinId').value == null"> Annual Plan Items</span>
                <span [hidden]=" expenseClaimForm.get('hoshinId').value != null"
                *ngIf="(expenseClaimForm.get('expenseName').value == null || 
                 expenseClaimForm.get('expenseName').value == '' ||
                expenseClaimForm.get('totalExpense').value == null || expenseClaimForm.get('expenseDesc').value == null ||
                 expenseClaimForm.get('expenseDesc').value== '')">,</span>

                <span
                    *ngIf="expenseClaimForm.get('expenseName').value == null || expenseClaimForm.get('expenseName').value == ''">
                    Expense Name</span>
                <span
                    [hidden]="expenseClaimForm.get('expenseName').value != null && expenseClaimForm.get('expenseName').value != ''"
                    *ngIf="(expenseClaimForm.get('totalExpense').value == null || expenseClaimForm.get('expenseDesc').value == null ||
                     expenseClaimForm.get('expenseDesc').value== '')">,</span>

                <span
                    *ngIf="expenseClaimForm.get('totalExpense').value == null || expenseClaimForm.get('totalExpense').value == ''">
                    Total Expense</span>
                <span
                    [hidden]="expenseClaimForm.get('totalExpense').value != null && expenseClaimForm.get('totalExpense').value != ''"
                      *ngIf="(expenseClaimForm.get('expenseDesc').value == null ||
                     expenseClaimForm.get('expenseDesc').value== '')">,</span>

                <span
                    *ngIf="expenseClaimForm.get('expenseDesc').value == null || expenseClaimForm.get('expenseDesc').value == ''">
                    Expense Description</span>
                <!-- <span
                    [hidden]="expenseClaimForm.get('expenseDesc').value != null && expenseClaimForm.get('expenseDesc').value != ''"
                    *ngIf="(expenseClaimForm.get('detailedEventPurpose').value == null ||
                     expenseClaimForm.get('detailedEventPurpose').value == '')">,</span>

                <span
                    *ngIf="expenseClaimForm.get('detailedEventPurpose').value == null || expenseClaimForm.get('detailedEventPurpose').value == ''">
                    Purpose</span> -->
            </span>
            <div class="form-group expense-btnalign-for-ipad">
                <button type="button" (click)="saveClick()" [disabled]="expenseClaimForm.invalid" data-toggle="modal"
                    data-target="#myModal"
                    class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin">SAVE</button>
                <button type="button" (click)="submitClick()" [disabled]="expenseClaimForm.invalid" data-toggle="modal"
                    data-target="#myModal"
                    class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin">SAVE
                    & SUBMIT</button>
                <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin"
                    data-toggle="modal" data-target="#myModal" (click)="cancelClick()">CANCEL</button>
                <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
            </div>
        </form>
    </div>
</div>